// Comprehensive Chapter and Topic Structure for JEE and NEET

export const CHAPTERS_TOPICS = {
  Physics: [
  {
    chapter: "Units and Measurements",
    topics: [
      "Units of Measurement",
      "System of Units",
      "SI Units",
      "Fundamental and Derived Units",
      "Least Count",
      "Significant Figures",
      "Errors in Measurement",
      "Dimensions of Physical Quantities",
      "Dimensional Analysis and Applications"
    ]
  },
  {
    chapter: "Kinematics",
    topics: [
      "Frame of Reference",
      "Motion in Straight Line",
      "Position-Time Graph",
      "Speed and Velocity",
      "Uniform and Non-uniform Motion",
      "Average and Instantaneous Velocity",
      "Uniformly Accelerated Motion",
      "Velocity-Time Graph",
      "Position-Time Graph Relations",
      "Relative Velocity",
      "Scalars and Vectors",
      "Vector Addition and Subtraction",
      "Scalar and Vector Products",
      "Unit Vector",
      "Resolution of Vectors",
      "Motion in Plane",
      "Projectile Motion",
      "Uniform Circular Motion"
    ]
  },
  {
    chapter: "Laws of Motion",
    topics: [
      "Force and Inertia",
      "Newton’s Laws of Motion",
      "Momentum",
      "Impulse",
      "Law of Conservation of Momentum",
      "Equilibrium of Concurrent Forces",
      "Static and Kinetic Friction",
      "Laws of Friction",
      "Rolling Friction",
      "Dynamics of Uniform Circular Motion",
      "Centripetal Force",
      "Vehicle on Level Road",
      "Vehicle on Banked Road"
    ]
  },
  {
    chapter: "Work, Energy and Power",
    topics: [
      "Work Done by Constant Force",
      "Work Done by Variable Force",
      "Kinetic and Potential Energy",
      "Work-Energy Theorem",
      "Power",
      "Spring Potential Energy",
      "Conservative and Non-Conservative Forces",
      "Motion in Vertical Circle",
      "Elastic and Inelastic Collisions (1D & 2D)"
    ]
  },
  {
    chapter: "Rotational Motion",
    topics: [
      "Centre of Mass",
      "Rotational Motion Concepts",
      "Moment of Force (Torque)",
      "Angular Momentum",
      "Conservation of Angular Momentum",
      "Moment of Inertia",
      "Radius of Gyration",
      "MOI of Simple Bodies",
      "Parallel & Perpendicular Axis Theorem",
      "Equilibrium of Rigid Bodies",
      "Rigid Body Rotation",
      "Comparison of Linear & Rotational Motion"
    ]
  },
  {
    chapter: "Gravitation",
    topics: [
      "Universal Law of Gravitation",
      "Acceleration Due to Gravity",
      "Variation with Height & Depth",
      "Kepler’s Laws",
      "Gravitational Potential Energy",
      "Gravitational Potential",
      "Escape Velocity",
      "Satellite Motion",
      "Orbital Velocity",
      "Time Period",
      "Energy of Satellite"
    ]
  },
  {
    chapter: "Properties of Solids and Liquids",
    topics: [
      "Elastic Behaviour",
      "Stress-Strain Curve",
      "Hooke's Law",
      "Young’s, Bulk & Shear Modulus",
      "Pressure in Fluids",
      "Pascal’s Law",
      "Viscosity",
      "Stokes’ Law",
      "Terminal Velocity",
      "Streamline & Turbulent Flow",
      "Critical Velocity",
      "Bernoulli’s Principle",
      "Surface Tension",
      "Surface Energy",
      "Angle of Contact",
      "Excess Pressure",
      "Capillarity",
      "Heat & Temperature",
      "Thermal Expansion",
      "Specific Heat",
      "Calorimetry",
      "Change of State & Latent Heat",
      "Modes of Heat Transfer"
    ]
  },
  {
    chapter: "Thermodynamics",
    topics: [
      "Thermal Equilibrium",
      "Zeroth Law",
      "Heat, Work & Internal Energy",
      "First Law of Thermodynamics",
      "Isothermal and Adiabatic Processes",
      "Second Law of Thermodynamics",
      "Reversible and Irreversible Processes"
    ]
  },
  {
    chapter: "Kinetic Theory of Gases",
    topics: [
      "Equation of State of Gas",
      "Work Done on Gas",
      "Assumptions of Kinetic Theory",
      "Pressure of Gas",
      "Kinetic Interpretation of Temperature",
      "RMS Speed",
      "Degrees of Freedom",
      "Law of Equipartition of Energy",
      "Specific Heat of Gases",
      "Mean Free Path",
      "Avogadro’s Number"
    ]
  },
  {
    chapter: "Oscillations and Waves",
    topics: [
      "Periodic Motion",
      "Time Period & Frequency",
      "SHM and Equation",
      "Phase",
      "Spring–Mass System",
      "Energy in SHM",
      "Simple Pendulum",
      "Wave Motion",
      "Longitudinal & Transverse Waves",
      "Wave Speed",
      "Wave Equation",
      "Superposition Principle",
      "Reflection of Waves",
      "Standing Waves",
      "Harmonics",
      "Beats"
    ]
  },
  {
    chapter: "Electrostatics",
    topics: [
      "Electric Charge",
      "Coulomb’s Law",
      "Superposition Principle",
      "Electric Field",
      "Electric Field Lines",
      "Electric Dipole",
      "Torque on Dipole",
      "Gauss's Law & Applications",
      "Electric Flux",
      "Electric Potential",
      "Equipotential Surfaces",
      "Potential Energy",
      "Conductors & Insulators",
      "Dielectrics",
      "Polarization",
      "Capacitors",
      "Capacitors in Series & Parallel",
      "Parallel Plate Capacitor with Dielectric",
      "Energy Stored in Capacitor"
    ]
  },
  {
    chapter: "Current Electricity",
    topics: [
      "Electric Current",
      "Drift Velocity",
      "Mobility",
      "Ohm’s Law",
      "Resistance",
      "IV Characteristics",
      "Resistivity & Conductivity",
      "Series and Parallel Resistors",
      "Temperature Dependence",
      "EMF & Internal Resistance",
      "Cells in Series & Parallel",
      "Kirchhoff’s Laws",
      "Wheatstone Bridge",
      "Meter Bridge"
    ]
  },
  {
    chapter: "Magnetic Effects of Current and Magnetism",
    topics: [
      "Biot-Savart Law",
      "Ampere's Law",
      "Magnetic Force on Charge",
      "Force on Current Carrying Conductor",
      "Force Between Two Parallel Currents",
      "Torque on Current Loop",
      "Moving Coil Galvanometer",
      "Magnetic Dipole",
      "Bar Magnet as Solenoid",
      "Field on Axis & Perpendicular",
      "Para, Dia & Ferromagnetism",
      "Temperature Effect"
    ]
  },
  {
    chapter: "Electromagnetic Induction & Alternating Current",
    topics: [
      "Faraday’s Law",
      "Lenz's Law",
      "Eddy Currents",
      "Self & Mutual Inductance",
      "AC Basics",
      "Peak & RMS Values",
      "Reactance & Impedance",
      "LCR Series Circuit",
      "Resonance",
      "Power in AC Circuits",
      "Wattless Current",
      "AC Generator",
      "Transformer"
    ]
  },
  {
    chapter: "Electromagnetic Waves",
    topics: [
      "Displacement Current",
      "Characteristics of EM Waves",
      "Transverse Nature",
      "Electromagnetic Spectrum",
      "Applications of EM Waves"
    ]
  },
  {
    chapter: "Optics",
    topics: [
      "Reflection",
      "Spherical Mirrors",
      "Mirror Formula",
      "Refraction",
      "Lens Formula",
      "Lens Maker Formula",
      "TIR and Applications",
      "Power of Lens",
      "Combination of Lenses",
      "Prism",
      "Microscope & Telescope",
      "Huygens Principle",
      "Interference",
      "Double Slit Experiment",
      "Diffraction",
      "Polarisation",
      "Brewster's Law",
      "Uses of Polaroids"
    ]
  },
  {
    chapter: "Dual Nature of Matter and Radiation",
    topics: [
      "Dual Nature of Radiation",
      "Photoelectric Effect",
      "Einstein’s Equation",
      "Matter Waves",
      "de Broglie Wavelength"
    ]
  },
  {
    chapter: "Atoms and Nuclei",
    topics: [
      "Alpha Scattering",
      "Rutherford Model",
      "Bohr Model",
      "Energy Levels",
      "Hydrogen Spectrum",
      "Nucleus & Composition",
      "Mass Defect",
      "Binding Energy",
      "Nuclear Fission & Fusion"
    ]
  },
  {
    chapter: "Electronic Devices",
    topics: [
      "Semiconductors",
      "Diode I-V Curve",
      "Diode as Rectifier",
      "LED",
      "Photodiode",
      "Solar Cell",
      "Zener Diode as Regulator",
      "Logic Gates (OR, AND, NOT, NAND, NOR)"
    ]
  }
],
  Chemistry: [
  {
    chapter: "Some Basic Concepts of Chemistry",
    topics: [
      "Matter and its Nature",
      "Dalton’s Atomic Theory",
      "Atom, Molecule, Element & Compound",
      "Laws of Chemical Combination",
      "Atomic and Molecular Masses",
      "Mole Concept",
      "Molar Mass",
      "Percentage Composition",
      "Empirical and Molecular Formula",
      "Chemical Equations and Stoichiometry"
    ]
  },
  {
    chapter: "Atomic Structure",
    topics: [
      "Electromagnetic Radiation",
      "Photoelectric Effect",
      "Hydrogen Spectrum",
      "Bohr Model",
      "Energy Levels and Radii",
      "Limitations of Bohr Model",
      "Dual Nature of Matter",
      "de Broglie Relation",
      "Heisenberg Uncertainty Principle",
      "Quantum Mechanical Model",
      "Atomic Orbitals",
      "Ψ and Ψ² for 1s and 2s",
      "Quantum Numbers",
      "Shapes of s, p, d Orbitals",
      "Electron Spin",
      "Aufbau Principle",
      "Pauli Exclusion Principle",
      "Hund’s Rule",
      "Electronic Configuration",
      "Stability of Half-filled & Fully-filled Orbitals"
    ]
  },
  {
    chapter: "Chemical Bonding and Molecular Structure",
    topics: [
      "Kossel-Lewis Approach",
      "Ionic Bonding",
      "Lattice Enthalpy",
      "Covalent Bonding",
      "Electronegativity",
      "Fajan’s Rule",
      "Dipole Moment",
      "VSEPR Theory & Molecular Shapes",
      "Valence Bond Theory",
      "Hybridization (s, p, d)",
      "Resonance",
      "Molecular Orbital Theory",
      "Bonding and Antibonding Orbitals",
      "Sigma & Pi Bonds",
      "Bond Order",
      "Bond Length & Bond Energy",
      "Metallic Bonding",
      "Hydrogen Bonding"
    ]
  },
  {
    chapter: "Chemical Thermodynamics",
    topics: [
      "Systems & Surroundings",
      "State Functions",
      "First Law of Thermodynamics",
      "Work, Heat & Internal Energy",
      "Enthalpy",
      "Heat Capacity",
      "Hess’s Law",
      "Enthalpy of Bond Dissociation",
      "Enthalpy of Combustion",
      "Enthalpy of Formation",
      "Enthalpy of Atomization",
      "Enthalpy of Sublimation",
      "Enthalpy of Phase Transition",
      "Enthalpy of Hydration",
      "Enthalpy of Solution",
      "Second Law of Thermodynamics",
      "Entropy",
      "Gibbs Free Energy",
      "ΔG° and Equilibrium Constant"
    ]
  },
  {
    chapter: "Solutions",
    topics: [
      "Concentration Methods (Molality, Molarity, Mole Fraction, %)",
      "Raoult’s Law",
      "Ideal and Non-Ideal Solutions",
      "Vapour Pressure–Composition Curves",
      "Colligative Properties",
      "Relative Lowering of Vapour Pressure",
      "Elevation of Boiling Point",
      "Depression of Freezing Point",
      "Osmotic Pressure",
      "Determination of Molar Mass",
      "Abnormal Molar Mass",
      "van’t Hoff Factor"
    ]
  },
  {
    chapter: "Equilibrium",
    topics: [
      "Dynamic Equilibrium",
      "Physical Equilibria",
      "Henry’s Law",
      "Law of Chemical Equilibrium",
      "Equilibrium Constant (Kp, Kc)",
      "Relation Between ΔG and Equilibrium",
      "Le Chatelier’s Principle",
      "Ionic Equilibrium",
      "Strong & Weak Electrolytes",
      "Acids & Bases (Arrhenius, Bronsted, Lewis)",
      "pH Scale",
      "Ionization Constants",
      "Common Ion Effect",
      "Hydrolysis of Salts",
      "Solubility Product",
      "Buffer Solutions"
    ]
  },
  {
    chapter: "Redox Reactions and Electrochemistry",
    topics: [
      "Oxidation & Reduction",
      "Oxidation Number",
      "Balancing Redox Reactions",
      "Electrolytic & Metallic Conduction",
      "Conductance & Conductivity",
      "Molar Conductivity",
      "Kohlrausch’s Law",
      "Electrochemical Cells",
      "Electrode Potential",
      "Standard Electrode Potential",
      "EMF of Cell",
      "Nernst Equation",
      "Gibbs Energy & Cell Potential",
      "Dry Cell",
      "Lead Storage Battery",
      "Fuel Cells"
    ]
  },
  {
    chapter: "Chemical Kinetics",
    topics: [
      "Rate of Reaction",
      "Factors Affecting Rate",
      "Order & Molecularity",
      "Rate Law",
      "Rate Constant",
      "Zero & First Order Reactions",
      "Half-Life",
      "Arrhenius Equation",
      "Activation Energy",
      "Collision Theory"
    ]
  },

  // INORGANIC CHEMISTRY
  {
    chapter: "Classification of Elements and Periodicity",
    topics: [
      "Modern Periodic Law",
      "Periodic Table",
      "s, p, d, f Blocks",
      "Atomic Radius",
      "Ionic Radius",
      "Ionization Enthalpy",
      "Electron Gain Enthalpy",
      "Valency",
      "Oxidation State",
      "Chemical Reactivity"
    ]
  },
  {
    chapter: "p-Block Elements",
    topics: [
      "Group 13–18 Elements",
      "Electronic Configuration",
      "Trends Across Periods",
      "Trends Down Groups",
      "Unique Behavior of First Elements"
    ]
  },
  {
    chapter: "d and f Block Elements",
    topics: [
      "Transition Elements",
      "Electronic Configuration",
      "General Trends of First Row",
      "Oxidation States",
      "Catalytic Behaviour",
      "Magnetic Properties",
      "Complex Formation",
      "Interstitial Compounds",
      "Alloy Formation",
      "K2Cr2O7 and KMnO4 — Preparation & Uses",
      "Lanthanoids & Lanthanoid Contraction",
      "Actinoids"
    ]
  },
  {
    chapter: "Coordination Compounds",
    topics: [
      "Werner’s Theory",
      "Ligands",
      "Coordination Number",
      "Denticity",
      "Chelation",
      "IUPAC Nomenclature",
      "Isomerism",
      "Valence Bond Theory",
      "Crystal Field Theory",
      "Colour & Magnetic Properties",
      "Importance & Applications"
    ]
  },

  // ORGANIC CHEMISTRY
  {
    chapter: "Purification and Characterisation of Organic Compounds",
    topics: [
      "Crystallization",
      "Sublimation",
      "Distillation",
      "Differential Extraction",
      "Chromatography",
      "Detection of Elements",
      "Estimation of C, H, N, Halogens, S, P",
      "Empirical & Molecular Formula",
      "Quantitative Calculations"
    ]
  },
  {
    chapter: "Some Basic Principles of Organic Chemistry",
    topics: [
      "Tetravalency of Carbon",
      "Shapes & Hybridization",
      "Classification of Organic Compounds",
      "Functional Groups",
      "Homologous Series",
      "Isomerism",
      "IUPAC & Trivial Names",
      "Homolysis & Heterolysis",
      "Carbocations, Carbanions & Free Radicals",
      "Electrophiles & Nucleophiles",
      "Inductive Effect",
      "Resonance",
      "Hyperconjugation",
      "Organic Reaction Mechanisms"
    ]
  },
  {
    chapter: "Hydrocarbons",
    topics: [
      "Classification & Nomenclature",
      "Preparation & Properties",
      "Alkanes — Conformations",
      "Halogenation Mechanism",
      "Alkenes — Electrophilic Addition",
      "Markovnikov & Peroxide Effect",
      "Ozonolysis",
      "Polymerization",
      "Alkynes — Acidic Nature",
      "Aromatic Hydrocarbons",
      "Friedel–Crafts Reactions",
      "Directive Influence"
    ]
  },
  {
    chapter: "Organic Compounds Containing Halogens",
    topics: [
      "Preparation & Properties",
      "Nature of C–X Bond",
      "Substitution Reaction Mechanisms",
      "Uses & Environmental Impact (DDT, Freons etc.)"
    ]
  },
  {
    chapter: "Organic Compounds Containing Oxygen",
    topics: [
      "Alcohols (Prep, Reactions, ID)",
      "Phenols (Acidity, Reactions)",
      "Ethers",
      "Aldehydes & Ketones",
      "Nucleophilic Addition",
      "Grignard Reagent",
      "Oxidation & Reduction",
      "Aldol & Cannizzaro Reaction",
      "Haloform Reaction",
      "Carboxylic Acids — Acidity & Factors"
    ]
  },
  {
    chapter: "Organic Compounds Containing Nitrogen",
    topics: [
      "Amines — Classification, Properties",
      "Basicity",
      "Reactions",
      "Diazonium Salts — Preparation & Uses"
    ]
  },
  {
    chapter: "Biomolecules",
    topics: [
      "Carbohydrates — Classification",
      "Glucose & Fructose",
      "Oligosaccharides",
      "Proteins — Structure Levels",
      "Amino Acids & Peptide Bond",
      "Enzymes",
      "Vitamins",
      "Nucleic Acids — DNA & RNA",
      "Hormones"
    ]
  },
  {
    chapter: "Principles Related to Practical Chemistry",
    topics: [
      "Detection of Elements",
      "Detection of Functional Groups",
      "Preparation of Inorganic Compounds",
      "Preparation of Organic Compounds",
      "Titrimetric Analysis",
      "Qualitative Salt Analysis",
      "Enthalpy Experiments",
      "Preparation of Sols",
      "Kinetics Experiment"
    ]
  }
],
  Mathematics: [
   [
  {
    chapter: "Sets, Relations and Functions",
    topics: [
      "Representation of Sets",
      "Union, Intersection and Complement",
      "Algebra of Sets",
      "Power Set",
      "Relations and Types of Relations",
      "Equivalence Relations",
      "Functions",
      "One–One, Into and Onto Functions",
      "Composition of Functions"
    ]
  },
  {
    chapter: "Complex Numbers and Quadratic Equations",
    topics: [
      "Complex Numbers as Ordered Pairs",
      "a + ib Form",
      "Argand Diagram",
      "Algebra of Complex Numbers",
      "Modulus and Argument",
      "Quadratic Equations (Real & Complex Solutions)",
      "Relation Between Roots and Coefficients",
      "Nature of Roots",
      "Formation of Quadratic Equations with Given Roots"
    ]
  },
  {
    chapter: "Matrices and Determinants",
    topics: [
      "Types of Matrices",
      "Algebra of Matrices",
      "Determinants (Order 2 and 3)",
      "Evaluation of Determinants",
      "Area of Triangle Using Determinants",
      "Adjoint of Matrix",
      "Inverse of Matrix",
      "Consistency of Linear Equations",
      "Solution of Linear Equations (2 or 3 Variables)"
    ]
  },
  {
    chapter: "Permutations and Combinations",
    topics: [
      "Fundamental Principle of Counting",
      "Permutation P(n, r)",
      "Combination C(n, r)",
      "Simple Applications"
    ]
  },
  {
    chapter: "Binomial Theorem",
    topics: [
      "Binomial Theorem for Positive Integer Index",
      "General Term",
      "Middle Term",
      "Applications of Binomial Theorem"
    ]
  },
  {
    chapter: "Sequence and Series",
    topics: [
      "Arithmetic Progression",
      "Geometric Progression",
      "Insertion of AM and GM",
      "Relation Between AM and GM"
    ]
  },
  {
    chapter: "Limits, Continuity and Differentiability",
    topics: [
      "Real Valued Functions",
      "Algebra of Functions",
      "Polynomial, Rational, Trigonometric, Logarithmic, Exponential Functions",
      "Inverse Functions",
      "Graphs of Simple Functions",
      "Limits",
      "Continuity",
      "Differentiability",
      "Differentiation Rules (Sum, Difference, Product, Quotient)",
      "Differentiation of Trigonometric Functions",
      "Inverse Trigonometric Functions",
      "Logarithmic & Exponential Functions",
      "Composite and Implicit Functions",
      "Higher Order Derivatives",
      "Rate of Change of Quantities",
      "Monotonicity (Increasing/Decreasing)",
      "Maxima and Minima (One Variable)"
    ]
  },
  {
    chapter: "Integral Calculus",
    topics: [
      "Integral as Anti-derivative",
      "Basic Standard Integrals",
      "Integration by Substitution",
      "Integration by Parts",
      "Integration by Partial Fractions",
      "Integration Using Trigonometric Identities",
      "Fundamental Theorem of Calculus",
      "Properties of Definite Integrals",
      "Evaluation of Definite Integrals",
      "Area Under Curve"
    ]
  },
  {
    chapter: "Differential Equations",
    topics: [
      "Order and Degree of Differential Equation",
      "Formation of Differential Equation",
      "Separation of Variables",
      "Homogeneous Differential Equation",
      "Linear Differential Equation dy/dx + Py = Q"
    ]
  },
  {
    chapter: "Coordinate Geometry",
    topics: [
      "Cartesian Coordinate System",
      "Distance Formula",
      "Section Formula",
      "Locus and Equation",
      "Slope of Line",
      "Parallel and Perpendicular Lines",
      "Intercepts of a Line",
      "Different Forms of Straight Line",
      "Intersection of Lines",
      "Angle Between Two Lines",
      "Concurrence of Lines",
      "Distance of a Point from a Line",
      "Centroid of Triangle",
      "Orthocentre",
      "Circumcentre",
      "Equation of Circle (Standard & General Form)",
      "Radius and Centre of Circle",
      "Circle with Endpoints of Diameter",
      "Intersection of Line and Circle",
      "Conic Sections – Parabola",
      "Conic Sections – Ellipse",
      "Conic Sections – Hyperbola"
    ]
  },
  {
    chapter: "Three Dimensional Geometry",
    topics: [
      "Coordinates of a Point in Space",
      "3D Distance Formula",
      "Section Formula in 3D",
      "Direction Ratios",
      "Direction Cosines",
      "Angle Between Two Lines",
      "Equation of a Line",
      "Skew Lines",
      "Shortest Distance Between Skew Lines"
    ]
  },
  {
    chapter: "Vector Algebra",
    topics: [
      "Scalars and Vectors",
      "Addition of Vectors",
      "Components of a Vector (2D and 3D)",
      "Scalar Product (Dot Product)",
      "Vector Product (Cross Product)"
    ]
  },
  {
    chapter: "Statistics and Probability",
    topics: [
      "Measures of Dispersion",
      "Mean (Grouped and Ungrouped)",
      "Median",
      "Mode",
      "Standard Deviation",
      "Variance",
      "Mean Deviation",
      "Probability of an Event",
      "Addition Theorem of Probability",
      "Multiplication Theorem of Probability",
      "Bayes Theorem",
      "Random Variable",
      "Probability Distribution"
    ]
  },
  {
    chapter: "Trigonometry",
    topics: [
      "Trigonometric Identities",
      "Trigonometric Functions",
      "Inverse Trigonometric Functions",
      "Properties of Inverse Trigonometric Functions"
    ]
  }
]
  ],
  Biology: [
  {
    chapter: "Diversity in Living World",
    topics: [
      "What is Living",
      "Biodiversity",
      "Need for Classification",
      "Taxonomy and Systematics",
      "Species Concept",
      "Taxonomical Hierarchy",
      "Binomial Nomenclature",
      "Five Kingdom Classification",
      "Monera",
      "Protista",
      "Fungi",
      "Lichens",
      "Viruses",
      "Viroids",
      "Plant Kingdom – Algae",
      "Plant Kingdom – Bryophytes",
      "Plant Kingdom – Pteridophytes",
      "Plant Kingdom – Gymnosperms",
      "Animal Kingdom – Non-chordates (Phylum Level)",
      "Animal Kingdom – Chordates (Class Level)"
    ]
  },
  {
    chapter: "Structural Organisation in Animals and Plants",
    topics: [
      "Morphology of Flowering Plants",
      "Modifications of Root, Stem and Leaf",
      "Plant Tissues",
      "Anatomy of Root, Stem, Leaf",
      "Inflorescence – Cymose and Racemose",
      "Flower",
      "Fruit",
      "Seed",
      "Family: Malvaceae",
      "Family: Cruciferae",
      "Family: Leguminosae",
      "Family: Compositae",
      "Family: Gramineae",
      "Animal Tissues",
      "Morphology & Anatomy of Frog",
      "Digestive System of Frog",
      "Respiratory System of Frog",
      "Circulatory System of Frog",
      "Nervous System of Frog",
      "Reproductive System of Frog"
    ]
  },
  {
    chapter: "Cell Structure and Function",
    topics: [
      "Cell Theory",
      "Prokaryotic Cell",
      "Eukaryotic Cell",
      "Plant Cell vs Animal Cell",
      "Cell Envelope, Cell Membrane & Cell Wall",
      "Cell Organelles",
      "Endoplasmic Reticulum",
      "Golgi Apparatus",
      "Lysosomes",
      "Vacuoles",
      "Mitochondria",
      "Ribosomes",
      "Plastids",
      "Microbodies",
      "Cytoskeleton",
      "Cilia & Flagella",
      "Centrioles",
      "Nucleus – Chromatin & Nucleolus",
      "Biomolecules – Proteins",
      "Biomolecules – Carbohydrates",
      "Biomolecules – Lipids",
      "Biomolecules – Nucleic Acids",
      "Enzymes – Types & Properties",
      "Enzyme Action & Classification",
      "Cell Cycle",
      "Mitosis",
      "Meiosis"
    ]
  },
  {
    chapter: "Plant Physiology",
    topics: [
      "Photosynthesis",
      "Photosynthetic Pigments",
      "Photochemical Phase",
      "Biosynthetic Phase",
      "Cyclic Photophosphorylation",
      "Non Cyclic Photophosphorylation",
      "Chemiosmotic Hypothesis",
      "Photorespiration",
      "C3 Pathway",
      "C4 Pathway",
      "Factors Affecting Photosynthesis",
      "Respiration",
      "Glycolysis",
      "Fermentation",
      "TCA Cycle",
      "Electron Transport System",
      "Energy Relations – ATP Yield",
      "Amphibolic Pathway",
      "Respiratory Quotient",
      "Plant Growth",
      "Growth Phases",
      "Differentiation",
      "Dedifferentiation",
      "Redifferentiation",
      "Growth Regulators – Auxin",
      "Growth Regulators – Gibberellin",
      "Growth Regulators – Cytokinin",
      "Growth Regulators – Ethylene",
      "Growth Regulators – ABA"
    ]
  },
  {
    chapter: "Human Physiology",
    topics: [
      "Human Respiratory System",
      "Mechanism of Breathing",
      "Exchange of Gases",
      "Transport of Gases",
      "Regulation of Breathing",
      "Respiratory Volumes",
      "Respiratory Disorders",
      "Blood Composition",
      "Blood Groups",
      "Blood Coagulation",
      "Lymph",
      "Human Heart Structure",
      "Blood Vessels",
      "Cardiac Cycle",
      "Cardiac Output",
      "ECG",
      "Double Circulation",
      "Heart Disorders",
      "Modes of Excretion",
      "Human Excretory System",
      "Urine Formation",
      "Osmoregulation",
      "Regulation of Kidney Function",
      "Excretory Disorders",
      "Muscle Types",
      "Muscle Contraction",
      "Skeletal System",
      "Joints",
      "Muscle & Skeletal Disorders",
      "Neuron Structure",
      "Nerve Impulse Conduction",
      "Human Nervous System",
      "Endocrine Glands",
      "Hormone Action",
      "Hormonal Disorders"
    ]
  },
  {
    chapter: "Reproduction",
    topics: [
      "Flower Structure",
      "Male Gametophyte",
      "Female Gametophyte",
      "Pollination Types",
      "Pollination Agencies",
      "Outbreeding Devices",
      "Pollen–Pistil Interaction",
      "Double Fertilisation",
      "Endosperm Development",
      "Embryo Development",
      "Seed Formation",
      "Fruit Formation",
      "Apomixis",
      "Parthenocarpy",
      "Polyembryony",
      "Male Reproductive System",
      "Female Reproductive System",
      "Spermatogenesis",
      "Oogenesis",
      "Menstrual Cycle",
      "Fertilisation & Implantation",
      "Embryonic Development",
      "Placenta Formation",
      "Parturition",
      "Lactation",
      "Reproductive Health",
      "STD Prevention",
      "Birth Control Methods",
      "MTP",
      "Amniocentesis",
      "Infertility",
      "IVF / ZIFT / GIFT"
    ]
  },
  {
    chapter: "Genetics and Evolution",
    topics: [
      "Mendelian Inheritance",
      "Incomplete Dominance",
      "Codominance",
      "Multiple Alleles",
      "Blood Group Inheritance",
      "Pleiotropy",
      "Polygenic Inheritance",
      "Chromosome Theory",
      "Sex Determination",
      "Linkage & Crossing Over",
      "Sex Linked Inheritance",
      "Mendelian Disorders",
      "Chromosomal Disorders",
      "DNA Structure",
      "RNA Structure",
      "DNA Packaging",
      "DNA Replication",
      "Central Dogma",
      "Transcription",
      "Genetic Code",
      "Translation",
      "Gene Regulation – Lac Operon",
      "Human Genome Project",
      "DNA Fingerprinting",
      "Protein Synthesis",
      "Origin of Life",
      "Evidences of Evolution",
      "Darwinism",
      "Modern Evolutionary Theory",
      "Mutation",
      "Recombination",
      "Natural Selection",
      "Gene Flow",
      "Genetic Drift",
      "Hardy-Weinberg Principle",
      "Adaptive Radiation",
      "Human Evolution"
    ]
  },
  {
    chapter: "Biology and Human Welfare",
    topics: [
      "Health and Disease",
      "Malaria",
      "Filariasis",
      "Ascariasis",
      "Typhoid",
      "Pneumonia",
      "Common Cold",
      "Amoebiasis",
      "Ringworm",
      "Dengue",
      "Chikungunya",
      "Immunity",
      "Vaccines",
      "Cancer",
      "HIV and AIDS",
      "Adolescence",
      "Drug Abuse",
      "Alcohol Abuse",
      "Microbes in Household",
      "Microbes in Industry",
      "Microbes in Sewage Treatment",
      "Microbes in Energy Production",
      "Biocontrol Agents",
      "Biofertilizers"
    ]
  },
  {
    chapter: "Biotechnology and Its Applications",
    topics: [
      "Recombinant DNA Technology",
      "Steps of Genetic Engineering",
      "Applications in Medicine",
      "Human Insulin Production",
      "Vaccines",
      "Gene Therapy",
      "Bt Crops",
      "GMOs",
      "Transgenic Animals",
      "Biosafety Issues",
      "Biopiracy",
      "Patents"
    ]
  },
  {
    chapter: "Ecology and Environment",
    topics: [
      "Organisms & Environment",
      "Population Interactions",
      "Mutualism",
      "Competition",
      "Predation",
      "Parasitism",
      "Population Growth",
      "Birth Rate & Death Rate",
      "Age Distribution",
      "Ecosystem Structure",
      "Ecosystem Components",
      "Productivity",
      "Decomposition",
      "Energy Flow",
      "Ecological Pyramids",
      "Biodiversity",
      "Patterns of Biodiversity",
      "Importance of Biodiversity",
      "Loss of Biodiversity",
      "Conservation Methods",
      "Biodiversity Hotspots",
      "Extinction",
      "Endangered Species",
      "Red Data Book",
      "Biosphere Reserves",
      "National Parks",
      "Sanctuaries",
      "Sacred Groves"
    ]
  }
]
};
// Helper function to get chapters for a subject
export const getChapters = (subject) => {
  return CHAPTERS_TOPICS[subject]?.map(item => item.chapter) || [];
};

// Helper function to get topics for a chapter
export const getTopics = (subject, chapter) => {
  const chapterData = CHAPTERS_TOPICS[subject]?.find(item => item.chapter === chapter);
  return chapterData?.topics || [];
};
